/*
 */

import React, { memo, SVGProps, useEffect, useRef } from "react";

export type DiagramProps = SVGProps<SVGSVGElement> & {
    animate?: boolean;
    includeTSS?: boolean;
    inletTSSPercent: number;
    outletTSSPercent: number;
};

const SvgComponent = ({ animate, includeTSS, inletTSSPercent, outletTSSPercent, ...rest }: DiagramProps) => {
  const mainRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    mainRef.current?.pauseAnimations();
  }, []);

  useEffect(() => {
    if (animate) {
      mainRef.current?.unpauseAnimations();
    } else {
      mainRef.current?.pauseAnimations();
    }
  }, [animate]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 1411 604"
      ref={mainRef}
      {...rest}
    >
      <g id="DAF-streamwise">
        <path
          id="Rectangle 296"
          fill="url(#paint0_linear_239_1415)"
          d="M1216 480h91l104 86h-91l-104-86Z"
        />
        <g id="outlet-chamber">
          <path
            id="Rectangle 305"
            fill="url(#paint1_linear_239_1415)"
            d="M1209 230v263H953V230h256Z"
          />
          <path
            id="Rectangle 295"
            fill="url(#paint2_linear_239_1415)"
            d="M1209 6.5V493l104 73V79L1209 6.5Z"
          />
          <path
            id="Rectangle 300"
            fill="var(--daf-outlet-tint-10)"
            fillOpacity=".4"
            d="M1209 156v336.5l104 74v-337L1209 156Z"
          />
          <path
            id="Rectangle 298"
            fill="url(#paint3_linear_239_1415)"
            d="M952 156h261l100 74h-258l-103-74Z"
            opacity=".9"
          />
          <path
            id="Union"
            fill="url(#paint4_linear_239_1415)"
            fillRule="evenodd"
            d="M1209 492H842h110l82 74H842h472l-105-74Z"
            clipRule="evenodd"
          />
          <path
            id="Rectangle 304"
            fill="url(#paint5_linear_239_1415)"
            d="M1213 156V7H961l100.6 74.5V156H1213Z"
          />
          <path
            id="Union_2"
            fill="url(#paint6_linear_239_1415)"
            fillRule="evenodd"
            d="M961 6h-8l104 74h262L1215 6H961Zm9.027 5 93.943 67h243L1213 10.98V11H970.027Z"
            clipRule="evenodd"
          />
        </g>
        <g id="middle-chamber">
          <path
            id="Rectangle 290"
            fill="url(#paint7_linear_239_1415)"
            d="M954 9H368v106.188l95.5-12.02 39 12.02L535 98.66l38 16.528 36.5-16.528 40 16.528 35-16.528 39 16.528 38-16.528 38 16.528L838 98.66l39 16.528 35.5-16.528 41.5 16.528V9.001Z"
            style={{ mixBlendMode: "darken" }}
          />
          <path
            id="Rectangle 297"
            fill="url(#paint8_linear_239_1415)"
            d="M953 494.841H368V115.188l95.5-12.02 39 12.02L535 98.66l38 16.528 36.5-16.528 40 16.528 35-16.528 39 16.528 38-16.528 38 16.528L838 98.66l39 16.528 35.5-16.528 40.5 16.528v379.653Z"
          />
          <path
            id="Rectangle 287"
            fill="#004058"
            d="m954 6.5-1 314.041 104 86.148V79.126L954 6.5Z"
          />
          <path
            id="Union_3"
            fill="url(#paint205_linear_239_1415)"
            fillRule="evenodd"
            d="M369 492.837h584l82 74.128H451l-82-74.128Z"
            clipRule="evenodd"
          />
          <g id="scraper">
            <g
              id="basic / gear-2"
              fill="white"
              fillRule="evenodd"
              clipRule="evenodd"
            >
              <path
                id="Part"
                d="M491.681 38.266c-.784-.56-1.176-.84-1.595-.924a2 2 0 0 0-1.106.092c-.4.152-.741.492-1.422 1.173l-2.169 2.17c-.681.68-1.022 1.021-1.174 1.421a2.006 2.006 0 0 0-.092 1.106c.085.42.365.812.924 1.596l1.18 1.65c.301.423.452.634.537.833.091.212.121.324.148.554.025.215-.009.565-.078 1.265a10.054 10.054 0 0 0 0 2.034c.069.7.104 1.05.078 1.266-.027.23-.057.341-.148.554-.085.199-.236.41-.537.832l-1.18 1.651c-.559.784-.839 1.176-.924 1.596-.074.37-.042.753.092 1.105.152.4.493.741 1.174 1.422l2.169 2.17c.681.68 1.022 1.021 1.422 1.173a2 2 0 0 0 1.106.092c.419-.085.811-.364 1.595-.924l1.652-1.18c.422-.302.633-.452.832-.538.212-.09.324-.12.553-.148.215-.025.566.01 1.266.08a10.337 10.337 0 0 0 2.033 0c.701-.07 1.051-.105 1.266-.08.229.027.341.057.554.148.199.086.41.236.832.538l1.651 1.18c.784.56 1.176.84 1.596.924.369.074.753.042 1.106-.092.4-.152.74-.493 1.421-1.174l2.17-2.17c.681-.68 1.021-1.02 1.173-1.42.135-.353.166-.737.092-1.107-.085-.42-.364-.811-.924-1.595l-1.18-1.651c-.301-.422-.452-.633-.537-.832a1.665 1.665 0 0 1-.148-.554c-.025-.215.009-.565.079-1.266a10.364 10.364 0 0 0 0-2.034c-.07-.7-.104-1.05-.079-1.265.027-.23.057-.342.148-.554.085-.199.236-.41.537-.832l1.18-1.651c.56-.784.839-1.176.924-1.595.074-.37.043-.754-.092-1.106-.152-.4-.492-.741-1.173-1.422l-2.17-2.17c-.681-.68-1.021-1.021-1.422-1.173a1.997 1.997 0 0 0-1.105-.092c-.42.085-.812.364-1.596.924l-1.65 1.18c-.423.3-.634.452-.833.537-.212.09-.324.12-.553.148-.215.025-.566-.01-1.266-.079a10.306 10.306 0 0 0-2.035 0c-.7.07-1.05.104-1.265.079a1.661 1.661 0 0 1-.554-.148c-.199-.085-.41-.236-.832-.538l-1.651-1.179Z"
                opacity=".32"
              ></path>
              <path
                id="Vector"
                d="M500.503 50.22a3.503 3.503 0 1 1-7.006 0 3.503 3.503 0 0 1 7.006 0Z"
              />

              <animateTransform
                attributeName="transform"
                type="rotate"
                // the weird numbers in the from and to are the point around which to rotate
                // which, for us, is the center of the element
                // worked out by selecting the element in the f12 tools, then
                // let box = $0.getBBox(); `${box.x + (box.width/2)} ${box.y + (box.height/2)}`
                from="0 497.0006103515625 50.21950340270996"
                to="360 497.0006103515625 50.21950340270996"
                dur="4s"
                repeatDur="indefinite"
              />
            </g>
            <g
              id="basic / gear-2_2"
              fill="white"
              fillRule="evenodd"
              clipRule="evenodd"
            >
              <path
                id="Part_2"
                d="M918.681 38.266c-.784-.56-1.176-.84-1.595-.924a2 2 0 0 0-1.106.092c-.4.152-.741.492-1.422 1.173l-2.169 2.17c-.681.68-1.022 1.021-1.174 1.421a2.006 2.006 0 0 0-.092 1.106c.085.42.365.812.924 1.596l1.18 1.65c.301.423.452.634.537.833.091.212.121.324.148.554.025.215-.009.565-.078 1.265a10.054 10.054 0 0 0 0 2.034c.069.7.104 1.05.078 1.266-.027.23-.057.341-.148.554-.085.199-.236.41-.537.832l-1.18 1.651c-.559.784-.839 1.176-.924 1.596-.074.37-.042.753.092 1.105.152.4.493.741 1.174 1.422l2.169 2.17c.681.68 1.022 1.021 1.422 1.173a2 2 0 0 0 1.106.092c.419-.085.811-.364 1.595-.924l1.652-1.18c.422-.302.633-.452.832-.538.212-.09.324-.12.553-.148.215-.025.566.01 1.266.08a10.337 10.337 0 0 0 2.033 0c.701-.07 1.051-.105 1.266-.08.229.027.341.057.554.148.199.086.41.236.832.538l1.651 1.18c.784.56 1.176.84 1.596.924.369.074.753.042 1.106-.092.4-.152.74-.493 1.421-1.174l2.17-2.17c.681-.68 1.021-1.02 1.173-1.42.135-.353.166-.737.092-1.107-.085-.42-.364-.811-.924-1.595l-1.18-1.651c-.301-.422-.452-.633-.537-.832a1.665 1.665 0 0 1-.148-.554c-.025-.215.009-.565.079-1.266a10.364 10.364 0 0 0 0-2.034c-.07-.7-.104-1.05-.079-1.265.027-.23.057-.342.148-.554.085-.199.236-.41.537-.832l1.18-1.651c.56-.784.839-1.176.924-1.595.074-.37.043-.754-.092-1.106-.152-.4-.492-.741-1.173-1.422l-2.17-2.17c-.681-.68-1.021-1.021-1.422-1.173a1.997 1.997 0 0 0-1.105-.092c-.42.085-.812.364-1.596.924l-1.65 1.18c-.423.3-.634.452-.833.537-.212.09-.324.12-.553.148-.215.025-.566-.01-1.266-.079a10.306 10.306 0 0 0-2.035 0c-.7.07-1.05.104-1.265.079a1.661 1.661 0 0 1-.554-.148c-.199-.085-.41-.236-.832-.538l-1.651-1.179Z"
                opacity=".32"
              />
              <path
                id="Vector_2"
                d="M927.503 50.22a3.503 3.503 0 1 1-7.006 0 3.503 3.503 0 0 1 7.006 0Z"
              />

              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 924.0006408691406 50.219505310058594"
                to="360 924.0006408691406 50.219505310058594"
                dur="4s"
                repeatDur="indefinite"
              />
            </g>
            <path
              d="M 491.034 32.542 H 929.966 A 17.534 17.534 0 0 1 947.5 50.076 V 50.077 A 17.534 17.534 0 0 1 929.966 67.611 H 491.034 A 17.534 17.534 0 0 1 473.5 50.077 V 50.076 A 17.534 17.534 0 0 1 491.034 32.542 Z"
              id="scraper-path"
              stroke="white"
              strokeWidth="5"
                      ></path>

            <g id="Frame 59" stroke="white" strokeWidth="3">
              {/* 
                Yes, these are all in the same spot. They're
                top left of the drawing, sticking out the top
                This is so that when they get animated using an animateMotion
                with the rotate="auto" on, they point in the right direction
                See https://oreillymedia.github.io/svg-essentials-examples/ch12/animate_motion_rotate.html
               */}
              <path id="scraper-1" d="m0 -2 8.486-8.485" />
              <path id="scraper-2" d="m0 -2 8.485-8.485" />
              <path id="scraper-3" d="m0 -2 8.485-8.485" />
              <path id="scraper-4" d="m0 -2 8.485-8.485" />
              <path id="scraper-5" d="m0 -2 8.485-8.485" />
              <path id="scraper-6" d="m0 -2 8.485-8.485" />
              <path id="scraper-7" d="m0 -2 8.485-8.485" />
              <path id="scraper-8" d="m0 -2 8.485-8.485" />
              <path id="scraper-9" d="m0 -2 8.485-8.485" />
              <path id="scraper-10" d="m0 -2 8.485-8.485" />
              <path id="scraper-11" d="m0 -2 8.485-8.485" />
              <path id="scraper-12" d="m0 -2 8.485-8.485" />
              <path id="scraper-13" d="m0 -2 8.485-8.485" />
              <path id="scraper-14" d="m0 -2 8.485-8.485" />
              <path id="scraper-15" d="m0 -2 8.485-8.485" />
            </g>
          </g>
          {/* 
          The delay here is so that they wait a bit before starting to animate 
          It doesn't mean that they'l literally *wait* this long before appearing, negative delay
          means that the engine works out where they would have been -x seconds ago
          and starts them from that position.
          */}
          <animateMotion
            href="#scraper-1"
            dur="30s"
            begin="-28s"
            repeatCount="indefinite"
            rotate="auto"
          >
            <mpath href="#scraper-path" />
          </animateMotion>
          <animateMotion
            href="#scraper-2"
            dur="30s"
            begin="-26s"
            repeatCount="indefinite"
            rotate="auto"
          >
            <mpath href="#scraper-path" />
          </animateMotion>
          <animateMotion
            href="#scraper-3"
            dur="30s"
            begin="-24s"
            repeatCount="indefinite"
            rotate="auto"
          >
            <mpath href="#scraper-path" />
          </animateMotion>
          <animateMotion
            href="#scraper-4"
            dur="30s"
            begin="-22s"
            repeatCount="indefinite"
            rotate="auto"
          >
            <mpath href="#scraper-path" />
          </animateMotion>
          <animateMotion
            href="#scraper-5"
            dur="30s"
            begin="-20s"
            repeatCount="indefinite"
            rotate="auto"
          >
            <mpath href="#scraper-path" />
          </animateMotion>
          <animateMotion
            href="#scraper-6"
            dur="30s"
            begin="-18s"
            repeatCount="indefinite"
            rotate="auto"
          >
            <mpath href="#scraper-path" />
          </animateMotion>
          <animateMotion
            href="#scraper-7"
            dur="30s"
            begin="-16s"
            repeatCount="indefinite"
            rotate="auto"
          >
            <mpath href="#scraper-path" />
          </animateMotion>
          <animateMotion
            href="#scraper-8"
            dur="30s"
            begin="-14s"
            repeatCount="indefinite"
            rotate="auto"
          >
            <mpath href="#scraper-path" />
          </animateMotion>
          <animateMotion
            href="#scraper-9"
            dur="30s"
            begin="-12s"
            repeatCount="indefinite"
            rotate="auto"
          >
            <mpath href="#scraper-path" />
          </animateMotion>
          <animateMotion
            href="#scraper-10"
            dur="30s"
            begin="-10s"
            repeatCount="indefinite"
            rotate="auto"
          >
            <mpath href="#scraper-path" />
          </animateMotion>
          <animateMotion
            href="#scraper-11"
            dur="30s"
            begin="-8s"
            repeatCount="indefinite"
            rotate="auto"
          >
            <mpath href="#scraper-path" />
          </animateMotion>
          <animateMotion
            href="#scraper-12"
            dur="30s"
            begin="-6s"
            repeatCount="indefinite"
            rotate="auto"
          >
            <mpath href="#scraper-path" />
          </animateMotion>
          <animateMotion
            href="#scraper-13"
            dur="30s"
            begin="-4s"
            repeatCount="indefinite"
            rotate="auto"
          >
            <mpath href="#scraper-path" />
          </animateMotion>
          <animateMotion
            href="#scraper-14"
            dur="30s"
            begin="-2s"
            repeatCount="indefinite"
            rotate="auto"
          >
            <mpath href="#scraper-path" />
          </animateMotion>
          <animateMotion
            href="#scraper-15"
            dur="30s"
            begin="0s"
            repeatCount="indefinite"
            rotate="auto"
          >
            <mpath href="#scraper-path" />
          </animateMotion>

          <path
            id="Rectangle 306"
            fill="#7FDCFF"
            fillOpacity=".5"
            d="M953 114.187v379.151l104 94.162V102.166l-33.5 12.021-36-16.529-34.5 16.529Z"
          />
          <g id="water-ripples" fill="#9d5d2f">
            <path
              id="Vector_3"
              d="M532.586 88.319c4.212-.203 9.046 1.572 12.669 3.599 11.908 6.666 20.287 24.623 35.685 12.391 10.213-8.113 18.253-19.206 33.711-15.19 11.519 2.99 20.276 18.066 29.273 19.238 14.925 1.945 22.248-20.011 40.44-20.214 17.843-.197 25.155 22.181 39.786 20.116 8.451-1.195 13.719-11.756 19.614-12.386 5.896-.63 9.38 6.163 5.768 11.164-1.167 1.616-8.09 7.291-10.029 8.694-11.197 8.096-24.633 8.003-35.713-.241-6.623-4.925-13.786-16.571-23.243-12.496-10.741 4.635-15.825 17.475-30.633 18.993-19.048 1.955-21.627-9.938-34.09-17.64-10.741-6.644-16.242 2.909-23.538 8.951-10.941 9.061-23.199 11.981-36.123 4.481-6.524-3.785-15.531-15.952-22.643-15.979-7.302-.033-16.759 12.205-23.616 16.116-13.753 7.85-31.489 2.778-40.446-9.783-4.657-6.53 2.728-14.084 9.707-9.017 4.434 3.215 7.735 8.474 13.914 9.236 13.258 1.632 22.42-19.217 39.507-20.033Z"
            />
            <path
              id="Vector_4"
              d="M759.586 88.319c4.212-.203 9.046 1.572 12.669 3.599 11.908 6.666 20.287 24.623 35.685 12.391 10.213-8.113 18.253-19.206 33.711-15.19 11.519 2.99 20.276 18.066 29.273 19.238 14.925 1.945 22.248-20.011 40.44-20.214 17.843-.197 25.155 22.181 39.786 20.116 8.451-1.195 13.719-11.756 19.614-12.386 5.896-.63 9.38 6.163 5.768 11.164-1.167 1.616-8.09 7.291-10.029 8.694-11.197 8.096-24.633 8.003-35.713-.241-6.623-4.925-13.786-16.571-23.243-12.496-10.741 4.635-15.825 17.475-30.633 18.993-19.048 1.955-21.627-9.938-34.09-17.64-10.741-6.644-16.242 2.909-23.538 8.951-10.941 9.061-23.199 11.981-36.123 4.481-6.524-3.785-15.531-15.952-22.643-15.979-7.302-.033-16.759 12.205-23.616 16.116-13.753 7.85-31.489 2.778-40.446-9.783-4.657-6.53 2.728-14.084 9.707-9.017 4.434 3.215 7.735 8.474 13.914 9.236 13.258 1.632 22.42-19.217 39.507-20.033Z"
            />
            <path
              id="Vector_5"
              d="M835.586 88.319c4.212-.203 9.046 1.572 12.669 3.599 11.908 6.666 20.287 24.623 35.685 12.391 10.213-8.113 18.253-19.206 33.711-15.19 11.519 2.99 20.276 18.066 29.273 19.238 14.925 1.945 22.248-20.011 40.44-20.214 17.846-.197 25.156 22.181 39.786 20.116 8.45-1.195 13.72-11.756 19.61-12.386 5.9-.63 9.38 6.163 5.77 11.164-1.16 1.616-8.09 7.291-10.03 8.694-11.19 8.096-24.63 8.003-35.71-.241-6.62-4.925-13.786-16.571-23.243-12.496-10.741 4.635-15.825 17.475-30.633 18.993-19.048 1.955-21.627-9.938-34.09-17.64-10.741-6.644-16.242 2.909-23.538 8.951-10.941 9.061-23.199 11.981-36.123 4.481-6.524-3.785-15.531-15.952-22.643-15.979-7.302-.033-16.759 12.205-23.616 16.116-13.753 7.85-31.489 2.778-40.446-9.783-4.657-6.53 2.728-14.084 9.707-9.017 4.434 3.215 7.735 8.474 13.914 9.236 13.258 1.632 22.42-19.217 39.507-20.033Z"
            />
          </g>
        </g>
        <path
          id="Rectangle 272_2"
          fill="url(#paint206_linear_239_1415)"
          d="M0 480h91l104 86h-91L0 480Z"
        />
        <path
          id="Rectangle 274"
          fill="url(#paint207_linear_239_1415)"
          d="M91 5.5V480l104 86V79L91 5.5Z"
        />
        <g id="inlet-chamber">
          <path
            id="Rectangle 279"
            fill="url(#paint208_linear_239_1415)"
            d="M201 492h168l97 74H201v-74Z"
          />
          <path
            id="Rectangle 281"
            fill="url(#paint209_linear_239_1415)"
            d="M368 6.5V321l104 86V80L368 6.5Z"
          />
          <path
            id="Rectangle 304_2"
            fill="url(#paint210_linear_239_1415)"
            d="M368 6.5V161l104 86V80L368 6.5Z"
          />
          <path
            id="Rectangle 303"
            fill="url(#paint211_linear_239_1415)"
            d="M195 156h174l104 74H195v-74Z"
            opacity=".9"
          />
          <path
            id="Rectangle 282"
            fill="var(--daf-inlet-shade-70)"
            d="M368 304v21.5l98 82V387l-98-83Z"
          />
          <path
            id="Rectangle 283"
            fill="var(--daf-inlet-tint-20)"
            fillOpacity=".5"
            d="m367 230 1 261.5 98 74.5V230h-99Z"
          />
          <path
            id="Rectangle 284"
            fill="url(#paint212_linear_239_1415)"
            d="M368 230v263H195V230h173Z"
          />
          <path
            id="Rectangle 289"
            fill="url(#paint213_linear_239_1415)"
            d="M368 156V6H93l102 74v76h173Z"
          />
        </g>
        <path
          id="Rectangle 273"
          fill="url(#paint214_linear_239_1415)"
          d="m103 604 1-38L0 480v42.5L103 604Z"
        />
        <g id="inlet-pipe">
          <ellipse
            id="Ellipse 6"
            cx="141.5"
            cy="402"
            fill="var(--daf-inlet-shade-80)"
            rx="16.5"
            ry="35"
          />
          <ellipse
            id="Ellipse 5"
            cx="145.5"
            cy="402"
            fill="var(--daf-inlet-tint-20)"
            rx="12.5"
            ry="27"
          />
          <path
            id="Rectangle 268"
            fill="url(#paint215_linear_239_1415)"
            d="M70 377h79v50H70z"
          />
          <g id="Group 572">
            <rect
              id="Rectangle 265"
              width="48"
              height="48"
              x="45"
              y="378"
              fill="white"
              stroke="var(--daf-inlet-shade-40)"
              strokeWidth="2"
              rx="24"
            />
            <rect
              id="Rectangle 266"
              width="48"
              height="46.667"
              x="45"
              y="378"
              fill="white"
              stroke="var(--daf-inlet-shade-40)"
              strokeWidth="2"
              rx="23.333"
            />
            <rect
              id="Rectangle 267"
              width="48"
              height="46"
              x="45"
              y="378"
              fill="white"
              stroke="var(--daf-inlet-shade-40)"
              strokeWidth="2"
              rx="23"
            />
            <rect
              id="Rectangle 264"
              width="48"
              height="48"
              x="45"
              y="378"
              stroke="var(--daf-inlet-shade-40)"
              strokeWidth="2"
              rx="24"
            />
            <g id="ant-design:arrow-right-outlined">
              <path
                id="Vector_6"
                fill="var(--daf-inlet-shade-40)"
                d="m75.174 401.226-6.887-5.978a.295.295 0 0 0-.191-.071h-1.614a.145.145 0 0 0-.094.255l6.383 5.542H62.105a.147.147 0 0 0-.146.146v1.094c0 .08.066.145.146.145H72.77l-6.384 5.542a.145.145 0 0 0 .095.255h1.668c.034 0 .069-.013.094-.036l6.931-6.012a.587.587 0 0 0 0-.882Z"
              />
            </g>
          </g>
        </g>
        <g id="outlet-pipe">
          <ellipse
            id="Ellipse 7"
            cx="1271.5"
            cy="402"
            fill="var(--daf-outlet-shade-90)"
            rx="16.5"
            ry="35"
          />
          <ellipse
            id="Ellipse 8"
            cx="1277.5"
            cy="402"
            fill="var(--daf-outlet-tint-10)"
            rx="12.5"
            ry="27"
          />
          <path
            id="Rectangle 302"
            fill="url(#paint216_linear_239_1415)"
            d="M1318 377h65v50h-65z"
          />
          <g id="Group 577">
            <rect
              id="Rectangle 265_2"
              width="48"
              height="48"
              x="1361"
              y="378"
              fill="white"
              stroke="var(--daf-outlet-shade-20)"
              strokeWidth="2"
              rx="24"
            />
            <rect
              id="Rectangle 266_2"
              width="48"
              height="46.667"
              x="1361"
              y="378"
              fill="white"
              stroke="var(--daf-outlet-shade-20)"
              strokeWidth="2"
              rx="23.333"
            />
            <rect
              id="Rectangle 267_2"
              width="48"
              height="46"
              x="1361"
              y="378"
              fill="white"
              stroke="var(--daf-outlet-shade-20)"
              strokeWidth="2"
              rx="23"
            />
            <rect
              id="Rectangle 264_2"
              width="48"
              height="48"
              x="1361"
              y="378"
              stroke="var(--daf-outlet-shade-20)"
              strokeWidth="2"
              rx="24"
            />
            <g id="ant-design:arrow-right-outlined_2">
              <path
                id="Vector_7"
                fill="var(--daf-outlet-shade-20)"
                d="m1391.17 401.226-6.88-5.978a.309.309 0 0 0-.19-.071h-1.62c-.13 0-.19.168-.09.255l6.38 5.542h-10.67c-.08 0-.14.066-.14.146v1.094c0 .08.06.145.14.145h10.67l-6.38 5.542c-.11.089-.04.255.09.255h1.67a.13.13 0 0 0 .09-.036l6.93-6.012a.472.472 0 0 0 .15-.199.52.52 0 0 0 0-.485.464.464 0 0 0-.15-.198Z"
              />
            </g>
          </g>
        </g>
        <g id="Rectangle 278">
          <path
            fill="url(#paint217_linear_239_1415)"
            d="M104 604h38v1307h-38z"
            transform="rotate(-90 104 604)"
          />
          <path
            stroke="white"
            strokeOpacity=".3"
            d="M104.5 603.5v-37h1306v37z"
          />
        </g>
        <g id="INLET" fill="black">
          <path
            id="Vector_8"
            d="M297.234 428.047v-2.32h12.186v2.32h-4.721V441h-2.744v-12.953h-4.721Z"
          />
          <path
            id="Vector_9"
            d="M285.045 441v-15.273h9.933v2.32h-7.166v4.146h6.652v2.319h-6.652v4.169h7.226V441h-9.993Z"
          />
          <path
            id="Vector_10"
            d="M273.045 441v-15.273h2.767v12.954h6.726V441h-9.493Z"
          />
          <path
            id="Vector_11"
            d="M269.926 425.727V441h-2.461l-7.197-10.403h-.126V441h-2.767v-15.273h2.476l7.189 10.411h.134v-10.411h2.752Z"
          />
          <path id="Vector_12" d="M254.274 425.727V441h-2.767v-15.273h2.767Z" />
        </g>
        <g id="FLOTATION TANK" fill="black">
          <path
            id="Vector_13"
            d="M781.084 441v-15.273h2.767v7.018h.186l5.959-7.018h3.378l-5.907 6.854 5.959 8.419H790.1l-4.556-6.548-1.693 1.999V441h-2.767Z"
          />
          <path
            id="Vector_14"
            d="M777.964 425.727V441h-2.461l-7.196-10.403h-.127V441h-2.767v-15.273h2.476l7.189 10.411h.134v-10.411h2.752Z"
          />
          <path
            id="Vector_15"
            d="M752.073 441h-2.953l5.377-15.273h3.415L763.297 441h-2.954l-4.079-12.141h-.119L752.073 441Zm.097-5.988h8.054v2.222h-8.054v-2.222Z"
          />
          <path
            id="Vector_16"
            d="M737.318 428.047v-2.32h12.186v2.32h-4.721V441h-2.744v-12.953h-4.721Z"
          />
          <path
            id="Vector_17"
            d="M729.556 425.727V441h-2.461l-7.197-10.403h-.126V441h-2.767v-15.273h2.476l7.189 10.411h.134v-10.411h2.752Z"
          />
          <path
            id="Vector_18"
            d="M714.285 433.364c0 1.645-.308 3.055-.925 4.228-.611 1.168-1.447 2.063-2.506 2.685-1.054.621-2.249.932-3.587.932-1.337 0-2.535-.311-3.594-.932-1.054-.627-1.889-1.524-2.506-2.692-.611-1.174-.917-2.581-.917-4.221 0-1.646.306-3.053.917-4.221.617-1.174 1.452-2.071 2.506-2.692 1.059-.622 2.257-.933 3.594-.933 1.338 0 2.533.311 3.587.933 1.059.621 1.895 1.518 2.506 2.692.617 1.168.925 2.575.925 4.221Zm-2.782 0c0-1.159-.181-2.136-.544-2.931-.358-.801-.855-1.405-1.492-1.812-.636-.413-1.369-.619-2.2-.619-.83 0-1.563.206-2.2.619-.636.407-1.136 1.011-1.498 1.812-.358.795-.537 1.772-.537 2.931 0 1.158.179 2.137.537 2.938.362.795.862 1.399 1.498 1.812.637.408 1.37.612 2.2.612.831 0 1.564-.204 2.2-.612.637-.413 1.134-1.017 1.492-1.812.363-.801.544-1.78.544-2.938Z"
          />
          <path id="Vector_19" d="M697.536 425.727V441h-2.766v-15.273h2.766Z" />
          <path
            id="Vector_20"
            d="M680.13 428.047v-2.32h12.185v2.32h-4.72V441h-2.745v-12.953h-4.72Z"
          />
          <path
            id="Vector_21"
            d="M669.307 441h-2.953l5.376-15.273h3.416L680.53 441h-2.953l-4.079-12.141h-.12L669.307 441Zm.097-5.988h8.054v2.222h-8.054v-2.222Z"
          />
          <path
            id="Vector_22"
            d="M654.552 428.047v-2.32h12.185v2.32h-4.72V441h-2.745v-12.953h-4.72Z"
          />
          <path
            id="Vector_23"
            d="M653.179 433.364c0 1.645-.308 3.055-.924 4.228-.612 1.168-1.447 2.063-2.506 2.685-1.054.621-2.25.932-3.587.932-1.337 0-2.536-.311-3.595-.932-1.054-.627-1.889-1.524-2.505-2.692-.612-1.174-.917-2.581-.917-4.221 0-1.646.305-3.053.917-4.221.616-1.174 1.451-2.071 2.505-2.692 1.059-.622 2.258-.933 3.595-.933 1.337 0 2.533.311 3.587.933 1.059.621 1.894 1.518 2.506 2.692.616 1.168.924 2.575.924 4.221Zm-2.781 0c0-1.159-.182-2.136-.545-2.931-.358-.801-.855-1.405-1.491-1.812-.637-.413-1.37-.619-2.2-.619-.83 0-1.564.206-2.2.619-.636.407-1.136 1.011-1.499 1.812-.358.795-.537 1.772-.537 2.931 0 1.158.179 2.137.537 2.938.363.795.863 1.399 1.499 1.812.636.408 1.37.612 2.2.612.83 0 1.563-.204 2.2-.612.636-.413 1.133-1.017 1.491-1.812.363-.801.545-1.78.545-2.938Z"
          />
          <path
            id="Vector_24"
            d="M628.127 441v-15.273h2.767v12.954h6.726V441h-9.493Z"
          />
          <path
            id="Vector_25"
            d="M615.718 441v-15.273h9.784v2.32h-7.018v4.146h6.347v2.319h-6.347V441h-2.766Z"
          />
        </g>
        <g id="OUTLET" fill="black">
          <path
            id="Vector_26"
            d="M1161.76 428.047v-2.32h12.18v2.32h-4.72V441h-2.74v-12.953h-4.72Z"
          />
          <path
            id="Vector_27"
            d="M1149.57 441v-15.273h9.93v2.32h-7.17v4.146h6.65v2.319h-6.65v4.169h7.23V441h-9.99Z"
          />
          <path
            id="Vector_28"
            d="M1137.57 441v-15.273h2.76v12.954h6.73V441h-9.49Z"
          />
          <path
            id="Vector_29"
            d="M1122.93 428.047v-2.32h12.18v2.32h-4.72V441h-2.74v-12.953h-4.72Z"
          />
          <path
            id="Vector_30"
            d="M1117.72 425.727h2.77v9.978c0 1.094-.26 2.056-.78 2.886-.51.831-1.23 1.479-2.16 1.947-.93.462-2.02.693-3.26.693-1.25 0-2.34-.231-3.27-.693-.93-.468-1.65-1.116-2.16-1.947-.51-.83-.77-1.792-.77-2.886v-9.978h2.77v9.747c0 .636.14 1.203.42 1.7.28.498.68.888 1.19 1.171.51.279 1.12.418 1.82.418s1.31-.139 1.82-.418a2.95 2.95 0 0 0 1.19-1.171c.28-.497.42-1.064.42-1.7v-9.747Z"
          />
          <path
            id="Vector_31"
            d="M1105.37 433.364c0 1.645-.31 3.055-.92 4.228-.62 1.168-1.45 2.063-2.51 2.685-1.05.621-2.25.932-3.59.932-1.33 0-2.53-.311-3.59-.932-1.06-.627-1.89-1.524-2.51-2.692-.61-1.174-.91-2.581-.91-4.221 0-1.646.3-3.053.91-4.221.62-1.174 1.45-2.071 2.51-2.692 1.06-.622 2.26-.933 3.59-.933 1.34 0 2.54.311 3.59.933 1.06.621 1.89 1.518 2.51 2.692.61 1.168.92 2.575.92 4.221Zm-2.78 0c0-1.159-.18-2.136-.55-2.931-.35-.801-.85-1.405-1.49-1.812-.63-.413-1.37-.619-2.2-.619-.83 0-1.56.206-2.2.619-.63.407-1.13 1.011-1.5 1.812-.35.795-.53 1.772-.53 2.931 0 1.158.18 2.137.53 2.938.37.795.87 1.399 1.5 1.812.64.408 1.37.612 2.2.612.83 0 1.57-.204 2.2-.612.64-.413 1.14-1.017 1.49-1.812.37-.801.55-1.78.55-2.938Z"
          />
        </g>
        <path
          id="Union_4"
          fill="url(#paint218_linear_239_1415)"
          fillRule="evenodd"
          d="M195 80h277v327h-6V86H201v480h-6V80Z"
          clipRule="evenodd"
        />
        <path
          id="Union_5"
          fill="url(#paint219_linear_239_1415)"
          fillRule="evenodd"
          d="M1057 102V80h262v486h-6V86h-250v320h-6V102Z"
          clipRule="evenodd"
        />
        <g id="inlet-to-middle-arrow">
          <path
            id="Vector 1"
            fill="url(#paint220_linear_239_1415)"
            d="m417 455 14.5-14.5c2 18 5.5 32 15 48-2.5 4-11 12.5-15 12.5s-9.5-1-18.5-11.5c-7.2-8.4-13.667-35.5-16-48l20 13.5Z"
          />
          <path
            id="Vector 2"
            fill="url(#paint221_linear_239_1415)"
            d="M444.5 454H457c-1.2 27.6-17.5 43.167-24.5 47H462c2.667.5 9.6-2.4 16-14s8.667-27.833 9-34.5h13.5L474 417l-29.5 37Z"
          />
        </g>
        <g id="middle-to-outlet-arrow">
          <path
            id="Vector 3"
            fill="url(#paint222_linear_239_1415)"
            d="m976 455 14.5-14.5c2 18 5.5 32 15 48-2.5 4-11 12.5-15 12.5s-9.5-1-18.5-11.5c-7.2-8.4-13.667-35.5-16-48l20 13.5Z"
          />
          <path
            id="Vector 4"
            fill="url(#paint223_linear_239_1415)"
            d="M1003.5 454h12.5c-1.2 27.6-17.5 43.167-24.5 47h29.5c2.67.5 9.6-2.4 16-14s8.67-27.833 9-34.5h13.5L1033 417l-29.5 37Z"
          />
        </g>
        <path
          id="Union_6"
          fill="url(#paint224_linear_239_1415)"
          fillRule="evenodd"
          d="M99 6h-8l104 74h277L368 6H99Zm359.378 70-91.351-65h-261l91.351 65h261Z"
          clipRule="evenodd"
        />
        <path
          id="Rectangle 312"
          fill="url(#paint225_linear_239_1415)"
          d="m76 1 119.5 84.5h8L84 1h-8Z"
        />
        <path id="Rectangle 320" fill="#4E6A7B" d="M195 90h6v36h-6z" />
        <path id="Rectangle 322" fill="#4E6A7B" d="M466 90h6v36h-6z" />
        <path
          id="Rectangle 323"
          fill="#4E6A7B"
          fillOpacity=".6"
          d="M1057 90h6v36h-6z"
        />
        <path
          id="Rectangle 324"
          fill="#4E6A7B"
          fillOpacity=".6"
          d="M1312 90h6v36h-6z"
        />
        <path
          id="Rectangle 321"
          fill="url(#paint226_linear_239_1415)"
          d="M195 90h1124v36H195z"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          id="Rectangle 315"
          fill="#5C7787"
          fillOpacity=".6"
          d="m91 19 104 67v39.5L91 25v-6Z"
        />
        <path
          id="Rectangle 311"
          fill="url(#paint227_linear_239_1415)"
          d="m76 0 120.5 85.5v9L76 11V0Z"
        />
        <path
          id="Rectangle 319"
          fill="url(#paint228_linear_239_1415)"
          d="M76.5 0H1218l-5 9H90.5l-14-9Z"
        />
        <path
          id="Rectangle 316"
          fill="url(#paint229_linear_239_1415)"
          d="M76 5.985A4.985 4.985 0 0 1 80.985 1h824.508a2.507 2.507 0 0 1 .015 5.015L81.015 10.97A4.985 4.985 0 0 1 76 5.985Z"
        />
        <g id="Group 583">
          <path
            id="Rectangle 317"
            fill="url(#paint230_linear_239_1415)"
            d="M1338.5 93.5 1219 9h-8l119.5 84.5h8Z"
          />
          <path
            id="Rectangle 318"
            fill="url(#paint231_linear_239_1415)"
            d="M1338.5 94.5 1212 9l6-9 120.5 80.5 1.5 6.5-1.5 7.5Z"
          />
        </g>
        <path
          id="Rectangle 313"
          fill="url(#paint232_linear_239_1415)"
          d="M196 84a4 4 0 0 0 4 4h1136a4 4 0 1 0 0-8H200a4 4 0 0 0-4 4Z"
        />
        <path
          id="Rectangle 314"
          fill="url(#paint233_linear_239_1415)"
          d="M196 90.5a3.5 3.5 0 0 0 3.5 3.5h1137c1.93 0 3.5-1.567 3.5-3.5s-1.57-3.5-3.5-3.5h-1137a3.5 3.5 0 0 0-3.5 3.5Z"
        />
      </g>
          <defs>
              {/* Gradient for 3D-like shading */}
              <radialGradient id="dotGradient" cx="50%" cy="50%" r="50%">
                  <stop offset="0%" stopColor="white" stopOpacity="0.8" />
                  <stop offset="100%" stopColor="#7FDCFF" stopOpacity="1" />
              </radialGradient>

              {/* Shadow filter for depth */}
              <filter id="dotShadow" x="-20%" y="-20%" width="140%" height="140%">
                  <feDropShadow dx="1" dy="1" stdDeviation="1.5" floodColor="black" floodOpacity="0.3" />
              </filter>

              {/* Clip paths for inlet and outlet chamber bounds */}
              {/*<clipPath id="inletClip">*/}
              {/*    <path d="M368 230v263H195V230h173Z" />*/}
              {/*</clipPath>*/}
              {/*<clipPath id="outletClip">*/}
              {/*    <path d="M1209 230v263H953V230h256Z" />*/}
              {/*</clipPath>*/}
              <clipPath id="inletClip">
                  <path d="M195 230h168l97 74v263H195V230Z" />
              </clipPath>
              <clipPath id="outletClip">
                  <path d="M1063 230h250v320H1063V230Z" />
              </clipPath>
              {/*<clipPath id="outletClip">
                  <path d="M953 230h256l104 74v263H953V230Z" />
              </clipPath>*/}
              <clipPath id="flotationClip">
                  <path d="M475 130h580v420H475V130Z" />
              </clipPath>
              {/*<clipPath id="flotationClip">
                  <path d="m964 6.5-1 314.041 114 86.148V79.126L964 6.5Z" />
              </clipPath>
              <clipPath id="flotationClips">
                  <path d="
                    M390 120       <!-- top-left corner of inner tank -->
                    L930 120       <!-- top-right corner -->
                    L930 480       <!-- bottom-right -->
                    L390 480       <!-- bottom-left -->
                    Z
                  " />
              </clipPath>*/}
        <linearGradient
          id="paint0_linear_239_1415"
          x1="1367"
          x2="1313.5"
          y1="506.5"
          y2="566"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B9499" />
          <stop offset="1" stopColor="#2E3133" />
        </linearGradient>

        <linearGradient
          id="paint1_linear_239_1415"
          x1="1081"
          x2="1081"
          y1="230"
          y2="493"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--daf-outlet-tint-20)" />
          <stop offset="1" stopColor="var(--daf-outlet)" />
        </linearGradient>

        <linearGradient
          id="paint2_linear_239_1415"
          x1="1261"
          x2="1261"
          y1="5.5"
          y2="566"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".596" stopColor="var(--daf-outlet-shade-70)" />
          <stop offset="1" stopColor="var(--daf-outlet-shade-40)" />
        </linearGradient>

        <linearGradient
          id="paint3_linear_239_1415"
          x1="952"
          x2="1313"
          y1="193"
          y2="193"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".327" stopColor="var(--daf-outlet-tint-10)" />
          <stop offset="1" stopColor="var(--daf-outlet-shade-10)" />
        </linearGradient>

        <linearGradient
          id="paint4_linear_239_1415"
          x1="1087"
          x2="1314"
          y1="529"
          y2="529"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--daf-outlet-shade-30)" />
          <stop offset="1" stopColor="var(--daf-outlet-shade-80)" />
        </linearGradient>

        <linearGradient
          id="paint5_linear_239_1415"
          x1="1087"
          x2="1087"
          y1="7"
          y2="156"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--daf-outlet-shade-50)" />
          <stop offset="1" stopColor="var(--daf-outlet-shade-60)" />
        </linearGradient>

        <linearGradient
          id="paint6_linear_239_1415"
          x1="936"
          x2="1319"
          y1="43"
          y2="43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B8B8B8" />
          <stop offset="1" stopColor="#C4C4C4" />
        </linearGradient>

        <linearGradient
          id="paint7_linear_239_1415"
          x1="662"
          x2="662"
          y1="70.111"
          y2="-44.586"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#125B76" />
          <stop offset="1" stopColor="#22AADC" />
        </linearGradient>

        <linearGradient
          id="paint8_linear_239_1415"
          x1="660.5"
          x2="660.5"
          y1="98.66"
          y2="494.841"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".62" stopColor="#7FDCFF" />
          <stop offset="1" stopColor="#63AECB" />
        </linearGradient>

        <linearGradient
          id="paint205_linear_239_1415"
          href="#paint7_linear_239_1415"
          x1="603"
          x2="607.515"
          y1="492.837"
          y2="566.964"
          gradientUnits="userSpaceOnUse"
        />

        <linearGradient
          id="paint206_linear_239_1415"
          href="#paint0_linear_239_1415"
          x1="63.5"
          x2="98"
          y1="530.5"
          y2="490"
          gradientUnits="userSpaceOnUse"
        />

        <linearGradient
          id="paint207_linear_239_1415"
          x1="143"
          x2="143"
          y1="5.5"
          y2="566"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A6C7DC" />
          <stop offset=".625" stopColor="#596B76" />
        </linearGradient>

        <linearGradient
          id="paint208_linear_239_1415"
          x1="275"
          x2="275"
          y1="544"
          y2="492"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--daf-inlet-shade-40)" />
          <stop offset="1" stopColor="var(--daf-inlet-shade-60)" />
        </linearGradient>

        <linearGradient
          id="paint209_linear_239_1415"
          x1="420"
          x2="420"
          y1="6.5"
          y2="407"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--daf-inlet-shade-80)" />
          <stop offset="1" stopColor="var(--daf-inlet-shade-50)" />
        </linearGradient>

        <linearGradient
          id="paint210_linear_239_1415"
          x1="420"
          x2="420"
          y1="6.5"
          y2="407"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#282828" />
          <stop offset="1" stopColor="var(--daf-inlet-shade-50)" />
        </linearGradient>

        <linearGradient
          id="paint211_linear_239_1415"
          x1="195"
          x2="473"
          y1="193"
          y2="193"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--daf-inlet)" />
          <stop offset="1" stopColor="var(--daf-inlet-shade-30)" />
        </linearGradient>

        <linearGradient
          id="paint212_linear_239_1415"
          x1="281.5"
          x2="281.5"
          y1="230"
          y2="493"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--daf-inlet-tint-20)" />
          <stop offset=".808" stopColor="var(--daf-inlet-tint-10)" />
          <stop offset="1" stopColor="var(--daf-inlet-shade-40)" />
        </linearGradient>

        <linearGradient
          id="paint213_linear_239_1415"
          x1="281.5"
          x2="281.5"
          y1="7"
          y2="156"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--daf-inlet-shade-40)" />
          <stop offset="1" stopColor="var(--daf-inlet-shade-50)" />
        </linearGradient>

        <linearGradient
          id="paint214_linear_239_1415"
          x1="52"
          x2="52"
          y1="480"
          y2="604"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D2C30" />
          <stop offset="1" stopColor="#365259" />
        </linearGradient>

        <linearGradient
          id="paint215_linear_239_1415"
          x1="149"
          x2="80.5"
          y1="402"
          y2="402"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--daf-inlet-tint-20)" />
          <stop offset=".606" stopColor="var(--daf-inlet-shade-40)" />
        </linearGradient>

        <linearGradient
          id="paint216_linear_239_1415"
          x1="1383"
          x2="1326.64"
          y1="402"
          y2="402"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".327" stopColor="var(--daf-outlet-shade-20)" />
          <stop offset="1" stopColor="var(--daf-outlet)" />
        </linearGradient>

        <linearGradient
          id="paint217_linear_239_1415"
          x1="142"
          x2="104"
          y1="1257.5"
          y2="1257.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".38" stopColor="#C0BEBE" />
          <stop offset="1" stopColor="#989696" />
        </linearGradient>

        <linearGradient
          id="paint218_linear_239_1415"
          x1="333.5"
          x2="333.5"
          y1="80"
          y2="566"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".034" stopColor="#D9D9D9" />
          <stop offset="1" stopColor="#737373" />
        </linearGradient>

        <linearGradient
          id="paint219_linear_239_1415"
          x1="1196"
          x2="1196"
          y1="80"
          y2="566"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D9D9D9" />
          <stop offset="1" stopColor="#8F8F8F" />
        </linearGradient>

        <linearGradient
          id="paint220_linear_239_1415"
          x1="421.75"
          x2="421.75"
          y1="440.5"
          y2="501"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--daf-inlet-shade-10)" />
          <stop offset="1" stopColor="var(--daf-inlet-shade-80)" />
        </linearGradient>

        <linearGradient
          id="paint221_linear_239_1415"
          x1="466.5"
          x2="466.5"
          y1="417"
          y2="501.053"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".538" stopColor="#008EC2" />
          <stop offset="1" stopColor="#27596B" />
        </linearGradient>

        <linearGradient
          id="paint222_linear_239_1415"
          x1="980.75"
          x2="980.75"
          y1="440.5"
          y2="501"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00BBFF" />
          <stop offset="1" stopColor="#1A404F" />
        </linearGradient>

        <linearGradient
          id="paint223_linear_239_1415"
          x1="1025.5"
          x2="1025.5"
          y1="417"
          y2="501.053"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".538" stopColor="var(--daf-outlet-shade-30)" />
          <stop offset="1" stopColor="var(--daf-outlet-shade-60)" />
        </linearGradient>

        <linearGradient
          id="paint224_linear_239_1415"
          x1="91"
          x2="472"
          y1="43"
          y2="43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D9D9D9" />
          <stop offset="1" stopColor="#737373" />
        </linearGradient>

        <linearGradient
          id="paint225_linear_239_1415"
          x1="131"
          x2="134.5"
          y1="41"
          y2="36"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EEEEEE" />
          <stop offset=".601" stopColor="#D9D9D9" />
        </linearGradient>

        <linearGradient
          id="paint226_linear_239_1415"
          x1="195"
          x2="195"
          y1="90"
          y2="126"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E6A7B" />
          <stop offset="1" stopColor="#4E6A7B" stopOpacity="0" />
        </linearGradient>

        <linearGradient
          id="paint227_linear_239_1415"
          x1="121.5"
          x2="117.5"
          y1="35"
          y2="41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4F4F4" />
          <stop offset="1" stopColor="#737373" />
        </linearGradient>

        <linearGradient
          id="paint228_linear_239_1415"
          x1="1031.5"
          x2="1031.5"
          y1="5"
          y2="-2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B9B9B9" />
          <stop offset=".673" stopColor="#969696" stopOpacity=".5" />
          <stop offset="1" stopColor="#737373" stopOpacity="0" />
        </linearGradient>

        <linearGradient
          id="paint229_linear_239_1415"
          x1="895.222"
          x2="76.434"
          y1="1"
          y2="21.148"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#919191" stopOpacity="0" />
          <stop offset=".135" stopColor="#B2B2B2" />
          <stop offset=".92" stopColor="#D2D2D2" />
          <stop offset="1" stopColor="#BEBEBE" stopOpacity=".7" />
        </linearGradient>

        <linearGradient
          id="paint230_linear_239_1415"
          href="#paint225_linear_239_1415"
          x1="1283.5"
          x2="1280"
          y1="53.5"
          y2="58.5"
          gradientUnits="userSpaceOnUse"
        />

        <linearGradient
          id="paint231_linear_239_1415"
          x1="1293"
          x2="1297"
          y1="59.5"
          y2="53.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DEDEDE" />
          <stop offset="1" stopColor="#737373" />
        </linearGradient>

        <linearGradient
          id="paint232_linear_239_1415"
          x1="723.312"
          x2="723.312"
          y1="88"
          y2="80"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EEEEEE" />
          <stop offset="1" stopColor="#888888" />
        </linearGradient>

        <linearGradient
          id="paint233_linear_239_1415"
          x1="723.312"
          x2="723.312"
          y1="94"
          y2="87"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#888888" />
          <stop offset="1" stopColor="#EEEEEE" />
        </linearGradient>
          </defs>
          {/* Dot overlays for inlet and outlet */}
          {(() => {
              const inletIntensity = 65;
              const outletIntensity = 30;

              const renderDots = (
                  count: number,
                  clipId: string,
                  xRange: [number, number],
                  yRange: [number, number],
                  color: string
              ) => (
                  <g opacity={count / 100} clipPath={`url(#${clipId})`}>
                      {[...Array(Math.round((count / 100) * 30))].map((_, i) => {
                          const x = xRange[0] + Math.random() * (xRange[1] - xRange[0]);
                          const y = yRange[0] + Math.random() * (yRange[1] - yRange[0]);
                          const offset = Math.random() * 2; // random delay

                          return (
                              <ellipse
                                  key={i}
                                  cx={x}
                                  cy={y}
                                  rx={6}
                                  ry={3.5}
                                  fill="url(#dotGradient)"
                                  filter="url(#dotShadow)"
                              >
                                  <animate
                                      attributeName="cy"
                                      values={`${y};${y - 10};${y}`}
                                      dur="4s"
                                      begin={`${offset}s`}
                                      repeatCount="indefinite"
                                  />
                              </ellipse>
                          );
                      })}
                  </g>
              );

              const renderBubbles = (
                  count: number,
                  clipId: string,
                  xRange: [number, number],
                  yRange: [number, number]
              ) => (
                  <g opacity={count / 100} clipPath={`url(#${clipId})`}>
                      {[...Array(Math.round((count / 100) * 30))].map((_, i) => {
                          const x = xRange[0] + Math.random() * (xRange[1] - xRange[0]);
                          const yStart = yRange[1]; // bottom of chamber
                          const yEnd = yRange[0];   // top of chamber
                          const duration = 3 + Math.random() * 2; // 3�5 seconds
                          const delay = Math.random() * 3;

                          return (
                              <ellipse
                                  key={i}
                                  cx={x}
                                  cy={yStart}
                                  rx={5}
                                  ry={3}
                                  fill="url(#dotGradient)"
                                  filter="url(#dotShadow)"
                              >
                                  <animate
                                      attributeName="cy"
                                      from={yStart}
                                      to={yEnd}
                                      dur={`${duration}s`}
                                      begin={`${delay}s`}
                                      repeatCount="indefinite"
                                  />
                                  <animate
                                      attributeName="opacity"
                                      values="0;1;1;0"
                                      keyTimes="0;0.1;0.9;1"
                                      dur={`${duration}s`}
                                      begin={`${delay}s`}
                                      repeatCount="indefinite"
                                  />
                              </ellipse>
                          );
                      })}
                  </g>
              );
              const renderFlotationBubbles = (
                  count: number,
                  clipId: string,
                  xRange: [number, number],
                  yRange: [number, number]
              ) => (
                  <g clipPath={`url(#${clipId})`} opacity={0.7}>
                      {[...Array(count)].map((_, i) => {
                          const x = xRange[0] + Math.random() * (xRange[1] - xRange[0]);
                          const yStart = yRange[1];
                          const yEnd = yRange[0];
                          const duration = 3 + Math.random() * 2;
                          const delay = Math.random() * 2;

                          return (
                              <ellipse
                                  key={`float-bubble-${i}`}
                                  cx={x}
                                  cy={yStart}
                                  rx={3.5 + Math.random() * 1.5}
                                  ry={2}
                                  fill="url(#dotGradient)"
                                  filter="url(#dotShadow)"
                              >
                                  <animate
                                      attributeName="cy"
                                      from={yStart}
                                      to={yEnd}
                                      dur={`${duration}s`}
                                      begin={`${delay}s`}
                                      repeatCount="indefinite"
                                  />
                                  <animate
                                      attributeName="opacity"
                                      values="0;1;1;0"
                                      keyTimes="0;0.1;0.9;1"
                                      dur={`${duration}s`}
                                      begin={`${delay}s`}
                                      repeatCount="indefinite"
                                  />
                              </ellipse>
                          );
                      })}
                  </g>
              );


              const renderTssParticles = (
                  tssPercent: number,
                  clipId: string,
                  xRange: [number, number],
                  yRange: [number, number],
                  display?: boolean
              ) => {
                  const count = display ? Math.round((tssPercent / 100) * 400) : 0; // adjust max dots as needed

                  return (
                      <g clipPath={`url(#${clipId})`} opacity={0.8}>
                          {[...Array(count)].map((_, i) => {
                              const x = xRange[0] + Math.random() * (xRange[1] - xRange[0]);
                              const y = yRange[0] + Math.random() * (yRange[1] - yRange[0]);
                              const duration = 6 + Math.random() * 4;
                              const delay = Math.random() * 3;
                              const xDrift = 5 + Math.random() * 5; // �5�10px
                              const yDrift = 5 + Math.random() * 5; // �5�10px

                              return (
                                  /*<circle
                                      key={`tss-${clipId}-${i}`}
                                      cx={x}
                                      cy={y}
                                      r={5}
                                      fill="rgba(255, 255, 255, 0.2)"
                                  >
                                      <animate
                                          attributeName="cx"
                                          values={`${x};${x + xDrift};${x - xDrift};${x}`}
                                          dur={`${duration + 2}s`}
                                          begin={`${delay}s`}
                                          repeatCount="indefinite"
                                      />
                                      <animate
                                          attributeName="cy"
                                          values={`${y};${y - yDrift};${y + yDrift};${y}`}
                                          dur={`${duration}s`}
                                          begin={`${delay}s`}
                                          repeatCount="indefinite"
                                      />
                                  </circle>*/
                                  <ellipse
                                      rx={5 + Math.random() * 2}
                                      ry={4 + Math.random() * 1.5}

                                      key={`tss-${clipId}-${i}`}
                                      cx={x}
                                      cy={y}
                                      fill="rgba(102, 51, 0, 0.5)"
                                  >
                                      <animate
                                          attributeName="cx"
                                          values={`${x};${x + xDrift * 0.5};${x - xDrift};${x + xDrift};${x}`}
                                          dur={`${duration + 3}s`}
                                          begin={`${delay}s`}
                                          repeatCount="indefinite"
                                      />
                                      <animate
                                          attributeName="cy"
                                          values={`${y};${y - yDrift};${y + yDrift * 1.5};${y - yDrift * 0.5};${y}`}
                                          dur={`${duration + 1}s`}
                                          begin={`${delay}s`}
                                          repeatCount="indefinite"
                                      />
                                  </ellipse>
                              );
                          })}
                      </g>
                  );
              };

              return (
                  <>
                      {renderTssParticles(inletTSSPercent, "inletClip", [200, 460], [250, 530], includeTSS)}
                      {renderTssParticles(outletTSSPercent, "outletClip", [1062, 1313], [250, 530], includeTSS)}
                      
                      {renderFlotationBubbles(60, "flotationClip", [470, 1050], [200, 470])}
                  </>
              );
          })()}
          {/*<rect
              x={800}
              y={200}
              width={1000}
              height={1000}
              fill="blue"
              opacity={0.9}
              clipPath="url(#outletClip)"
          />*/}
    </svg>
  );
};

const memoizedSvgComponent = memo(SvgComponent);

export default memoizedSvgComponent;
